import { render, staticRenderFns } from "./ImportPrepostUpload.vue?vue&type=template&id=0c7eed35"
import script from "./ImportPrepostUpload.vue?vue&type=script&lang=js"
export * from "./ImportPrepostUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports